import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const PrivateLimitedCompany = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/private_icon.jpg'></img>
                                    <Title text="Private Limited Company" className="custom-heading" />
                                </div>
                            </div>
                            <div className='discriptions'>
                                <p>If you’re looking to embark on a business venture in India, setting up a private limited company is like putting on a shiny suit of armor. With limited liability for shareholders, it offers a shield of protection against any unforeseen obstacles. However, like any suit of armor, there are requirements to meet before you can don this protective gear. At Vanani & Associates, we provide comprehensive services to help you establish and manage your Private Limited Company (PLC) efficiently. Our expertise ensures that you can focus on your business while we handle the legal and compliance aspects.</p>
                            </div>

                            <div className="why-choose-timeline">
                                <h4 className="timeline-title">Why Choose a <sapn className="key_features">Private Limited Company?</sapn></h4>
                                <div className="timeline">
                                    <div className="timeline-item">
                                        <div className="timeline-dot"></div>
                                        <div className="timeline-content">
                                            <h5>Limited Liability</h5>
                                            <p>Shareholders' liability is limited to their capital contribution, protecting personal assets from business liabilities.</p>
                                        </div>
                                    </div>
                                    <div className="timeline-item">
                                        <div className="timeline-dot"></div>
                                        <div className="timeline-content">
                                            <h5>Separate Legal Entity</h5>
                                            <p>A PLC is a separate legal entity from its shareholders, offering greater credibility and continuity.</p>
                                        </div>
                                    </div>
                                    <div className="timeline-item">
                                        <div className="timeline-dot"></div>
                                        <div className="timeline-content">
                                            <h5>Ease of Raising Capital</h5>
                                            <p>PLCs can easily attract funding from investors and financial institutions.</p>
                                        </div>
                                    </div>
                                    <div className="timeline-item">
                                        <div className="timeline-dot"></div>
                                        <div className="timeline-content">
                                            <h5>Growth Potential</h5>
                                            <p>PLCs offer stability and a structure conducive to growth and expansion.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className='row mt-5 m-0 company_egistratio'>
                                <div className='col-md-7'>
                                    <div className='check_list_wrap mt-2'>
                                        <h4 className='mb-3'>Benefits of Pvt Ltd <sapn className="key_features">Company Registratio</sapn></h4>
                                        <ul className='mb-0'>
                                            <li><strong>Authenticity:</strong>Registering a private limited company enhances the credibility and authenticity of your business.</li>
                                            <li><strong>Protection from Personal Liability:  </strong>Shareholders are protected from personal liability, ensuring their assets are safe from business risks.</li>
                                            <li className="content_company"><strong>Attracting Customers and Investors:  </strong>A registered company can attract more customers and investments from reliable sources.</li>
                                            <li className="content_company"><strong>Asset Protection:  </strong>Company assets are safeguarded, providing more stability for the business.</li>
                                            <li className="content_company"><strong>Potential for Growth:  </strong>With a clear structure and legal recognition, a PLC can grow and expand more effectively.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='col-md-5 p-0'>
                                    <div className='box_shadow mb-4'>
                                        <img className='img_width' src='/images/private_limited_bnr.jpg' alt='Partnership Firm'></img>
                                    </div>
                                </div>
                            </div>

                            <div className="checklist_wrapper">
                                <h4 className="checklist_title">
                                    <span className="key_features">Checklist</span> for Private Limited Company Registration in India
                                </h4>
                                <p className="checklist_subtitle">
                                    Creating a private limited company in India is a straightforward process, but you need to ensure that you follow the checklist requirements as defined by the Companies Act, 2013:</p>

                                <div className="checklist_grid">
                                    <div className="checklist_card">
                                        <div className="icon">👥</div>
                                        <h5>Minimum Requirements</h5>
                                        <ul>
                                            <li><b>Directors:</b> At least 2 Directors, with one being an Indian resident and citizen.</li>
                                            <li><b>Shareholders:</b>At least 2 Shareholders, who can also be Directors.</li>
                                            <li><b>Office:</b>A registered office in India, which can even be your rented home.</li>
                                        </ul>
                                    </div>

                                    <div className="checklist_card">
                                        <div className="icon">🏷️</div>
                                        <h5>Company Name</h5>
                                        <ul>
                                            <li>A unique name that reflects the company’s principal activity and includes “Private Limited Company”.</li>
                                        </ul>
                                    </div>

                                    <div className="checklist_card">
                                        <div className="icon">💰</div>
                                        <h5>Authorized Capital</h5>
                                        <ul>
                                            <li>A minimum authorized capital of ₹1 lakh.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="company_registration_in_india">
                                <h4><sapn className="key_features">Steps</sapn> for Company Registration in India</h4>
                                <div className="card-grid">
                                    <div className="card-step">
                                        <div className="step-number">1</div>
                                        <b>RUN Name Approval</b>
                                        <p>The initial stage of company registration involves reserving a unique name for your company by submitting a request to the Ministry of Corporate Affairs (MCA). Our professionals assist you in selecting the perfect name and registering it with the government.</p>
                                    </div>
                                    <div className="card-step">
                                        <div className="step-number">2</div>
                                        <b>Get Directors’ Digital Signature Certificate (DSC)</b>
                                        <p>In India, digital signatures are required for all filings with the MCA. We help directors obtain a DSC from a recognized certifying body.</p>
                                    </div>
                                    <div className="card-step full-width">
                                        <div className="step-number">3</div>
                                        <b>Submit the Company Incorporation Application</b>
                                        <p>After obtaining the required digital signatures, we submit the company incorporation application in the SPICe form along with all necessary documents to the MCA. The application includes the Memorandum of Association (MOA) and Articles of Association (AOA). Upon review and acceptance, the MCA issues an incorporation certificate and PAN for the company.</p>
                                    </div>
                                </div>
                            </div>

                            <div className='private_limited_company mt-2'>
                                <div className='col-md-12'>
                                    <div className='check_list_wrap mt-1'>
                                        <h4 className='mt-4 mb-2 font-weight-600'><sapn className="key_features">Private Limited Company</sapn> Compliances</h4>
                                        <p>Keeping up with various compliances is important for a registered company in India. After registration, a company must comply with requirements such as:</p>
                                        <ul>
                                            <li><strong>Appoint a Chartered Accountant:</strong>Within 30 days of incorporation, appoint a certified Chartered Accountant and file the annual income tax return using form ITR-6.</li>
                                            <li><strong>Annual Identity Verification: </strong>Submit DIN KYC to verify the phone number and email address on file with the MCA each year.</li>
                                            <li><strong>Deposit Subscription and Create a Bank Account: </strong>Shareholders must deposit the subscription amount within 180 days of incorporation and create a bank account for the company.</li>
                                            <li><strong>MCA Annual Filings: </strong>File annual returns and financial statements each financial year, including Forms MGT-7 and AOC-4.</li>
                                            <li><strong>Income Tax Filing: </strong>File the company’s income tax return using form ITR-6 each financial year.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="numbered-documents row mt-4">
                                <h4 className='mt-4 mb-2 font-weight-600'><sapn className="key_features">Documents Required</sapn> for Online Company Registration</h4>
                                <p>To register a private limited company in India, providing valid identity and address proof is mandatory. The following documents are accepted by the MCA:</p>
                                <div className="col-md-6">
                                    <div className="doc-box">
                                        <div className="doc-circle">1</div>
                                        <h5><b>Identity and Address Proof:</b></h5>
                                        <ul>
                                            <li>PAN card or passport (for foreign nationals and NRIs).</li>
                                            <li>Voter ID/passport/driving license.</li>
                                            <li>Latest bank statement/telephone or mobile bill/electricity or gas bill.</li>
                                            <li>Passport-sized photograph and specimen signature.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="doc-box">
                                        <div className="doc-circle">2</div>
                                        <h5><b>KYC Documents:</b></h5>
                                        <ul className='mt-2'>
                                            <li>Latest bank statement/telephone or mobile bill/electricity or gas bill.</li>
                                            <li>Notarized rental agreement in English.</li>
                                            <li>No-objection certificate from the property owner.</li>
                                            <li>Sale deed/property deed in English (in case of owned property).</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PrivateLimitedCompany;
